import { getTooltipHeader } from "app/UtilitiesAndConstants/UtilitiesComponents/chartTooltipHeaderWithMTDSupport";
import { ChangeTooltip } from "@similarweb/ui-components";
import { toggleItems } from "app/components/widget/widget-utilities/time-granularity";
import DurationService from "app/services/DurationService";
import { i18nFilter } from "app/filters/i18nFilter";
import { percentageSignFilter } from "app/filters/ngFilters";
import { getChange } from "app/pages/website-analysis/TrafficAndEngagement/ChartTooltips/CommonChartTooltip";

const changeTooltipProp =
    (formatter) =>
    ({ y, series, point }) => {
        const pointIndex = point.index;
        const previousDataPoint = pointIndex === 0 ? series.data[pointIndex].y : series.data[pointIndex - 1].y;
        const change = y / previousDataPoint - 1;
        return {
            value: formatter(y),
            color: series.color,
            displayName: i18nFilter()("audience.interest.overtime.tooltip.cross"),
            change: previousDataPoint !== 0 && getChange(previousDataPoint, change),
        };
    };

export const Tooltip = ({ points, params }) => {
    const i18n = i18nFilter();
    const { duration } = params;
    const { to } = DurationService.getDurationData(duration).forAPI;
    const changeTooltipProps = {
        header: getTooltipHeader(toggleItems.Monthly.value, points, String(to).replaceAll("|", "/")),
        tableHeaders: [
            { position: 0 },
            { position: 1, displayName: i18n("common.value") },
            { position: 2, displayName: i18n("common.tooltip.change") },
        ],
        tableRows: points.map(changeTooltipProp((value) => percentageSignFilter()(value, 2))),
        showChangeColumn: true,
    };
    return <ChangeTooltip {...changeTooltipProps} />;
};
